export const maxVisiblePages = 5;
export const productsPerPageWebsite = 16;
export const productsPerPageMobile = 8;
export const ITEMS_PER_PAGE = 16;